import { Alert } from '@mui/material';
import { ErrorNoDataStyled } from '@/styles/styledComponents/boxStyles';
import { TypographyStyled } from '@/styles/styledComponents/typographyStyles';

const ErrorMessage = ({ message }: { message?: string }) => (
    <ErrorNoDataStyled>
        <Alert severity="error" sx={{ mb: 2 }}>
            <TypographyStyled variant="subtitle1">
                {message || '오류가 발생했습니다. 다시 시도해주세요.'}
            </TypographyStyled>
        </Alert>
    </ErrorNoDataStyled>
);

export default ErrorMessage;
